import { ThemeMode, ThemeStyle, ThemeStyleRadius } from "../../../shared/constants/AppEnums";
import { isBreakPointDown } from "../Utils";
import {ContextState} from './index';
import {User as HPUser} from '../../../model/User';
// import {defaultUser} from '../../../shared/constants/AppConst';
import {removeJWT, setJWT, setRefreshToken, StorageKeyForRefreshToken} from '../../../api/Config';
import { RoutePermittedRole } from "shared/constants/AppConst";

export const ThemeSetting = {
  UPDATE_AUTH_USER: 'UPDATE_AUTH_USER',
  SET_INITIAL_PATH: 'SET_INITIAL_PATH',
  UPDATE_THEME: 'UPDATE_THEME',
  SET_FOOTER: 'SET_FOOTER',
  SET_FOOTER_TYPE: 'SET_FOOTER_TYPE',
  UPDATE_THEME_MODE: 'UPDATE_THEME_MODE',
  UPDATE_HEADER_MODE: 'UPDATE_HEADER_MODE',
  UPDATE_THEME_STYLE: 'UPDATE_THEME_STYLE',
  UPDATE_LAYOUT_STYLE: 'UPDATE_LAYOUT_STYLE',
  SET_RTL: 'SET_RTL',
  CHANGE_LOCALE: 'CHANGE_LOCALE',
  CHANGE_NAV_STYLE: 'CHANGE_NAV_STYLE',
  CHANGE_RT_ANIM: 'CHANGE_RT_ANIM',
  UPDATE_PRIMARY_COLOR: 'UPDATE_PRIMARY_COLOR',
  UPDATE_SIDEBAR_COLOR: 'UPDATE_SIDEBAR_COLOR',
  UPDATE_SECONDARY_COLOR: 'UPDATE_SECONDARY_COLOR',
};

export const HP_CustomActions = {
  SET_LOGGED_USER: 'SET_LOGGED_USER',
  SET_PENDING_PAYMENT: 'SET_PENDING_PAYMENT',
  SET_IS_REFRESHING_TOKEN: 'SET_IS_REFRESHING_TOKEN',
};

export function contextReducer(state: typeof ContextState, action: any) {
  switch (action.type) {
    case ThemeSetting.UPDATE_THEME: {
      return {
        ...state,
        theme: action.payload,
        primary: action.payload.palette.primary.main,
        secondary: action.payload.palette.secondary.main,
      };
    }
    case ThemeSetting.SET_INITIAL_PATH: {
      return {
        ...state,
        initialPath: action.payload,
      };
    }
    case ThemeSetting.UPDATE_AUTH_USER: {
      return {
        ...state,
        user: action.payload,
      };
    }
    case ThemeSetting.SET_FOOTER: {
      return {
        ...state,
        footer: action.payload,
      };
    }
    case ThemeSetting.SET_FOOTER_TYPE: {
      return {
        ...state,
        footerType: action.payload,
      };
    }
    case ThemeSetting.UPDATE_THEME_MODE: {
      let theme = state.theme;
      if (action.payload === ThemeMode.DARK) {
        theme.palette.type = ThemeMode.DARK;
        theme.palette.background = {
          paper: '#313541',
          default: '#393D4B',
        };
        theme.palette.text = {
          primary: 'rgba(255, 255, 255, 0.87)',
          secondary: 'rgba(255, 255, 255, 0.67)',
          disabled: 'rgba(255, 255, 255, 0.38)',
          hint: 'rgba(255, 255, 255, 0.38)',
        };
      } else {
        theme.palette.type = ThemeMode.LIGHT;
        theme.palette.background = {
          paper: '#FFFFFF',
          default: '#f3f4f6',
        };
        theme.palette.text = {
          primary: 'rgba(0, 0, 0, 0.87)',
          secondary: 'rgba(0, 0, 0, 0.67)',
          disabled: 'rgba(0, 0, 0, 0.38)',
          hint: 'rgba(0, 0, 0, 0.38)',
        };
      }
      return {
        ...state,
        theme,
        themeMode: action.payload,
      };
    }
    case ThemeSetting.UPDATE_HEADER_MODE: {
      return {
        ...state,
        headerMode: action.payload,
      };
    }
    case ThemeSetting.UPDATE_THEME_STYLE: {
      const theme = state.theme;

      if (action.payload === ThemeStyle.MODERN) {
        if (isBreakPointDown('md')) {
          theme.overrides.MuiCard.root.borderRadius = 20;
          theme.overrides.MuiToggleButton.root.borderRadius = 20;
        } else {
          theme.overrides.MuiCard.root.borderRadius = ThemeStyleRadius.MODERN;
          theme.overrides.MuiToggleButton.root.borderRadius =
            ThemeStyleRadius.MODERN;
        }
        theme.overrides.MuiButton.root.borderRadius = ThemeStyleRadius.MODERN;
        theme.overrides.MuiCardLg.root.borderRadius =
          ThemeStyleRadius.MODERN + 20;
      } else {
        theme.overrides.MuiCard.root.borderRadius = ThemeStyleRadius.STANDARD;
        theme.overrides.MuiToggleButton.root.borderRadius =
          ThemeStyleRadius.STANDARD;
        theme.overrides.MuiButton.root.borderRadius = ThemeStyleRadius.STANDARD;
        theme.overrides.MuiCardLg.root.borderRadius = ThemeStyleRadius.STANDARD;
      }

      return {
        ...state,
        theme,
        themeStyle: action.payload,
      };
    }
    case ThemeSetting.UPDATE_LAYOUT_STYLE: {
      return {
        ...state,
        layoutType: action.payload,
      };
    }
    case ThemeSetting.SET_RTL: {
      const theme = state.theme;
      if (action.payload) {
        theme.direction = 'rtl';
      } else {
        theme.direction = 'ltr';
      }
      return {
        ...state,
        theme,
        isRTL: action.payload,
      };
    }
    case ThemeSetting.CHANGE_LOCALE: {
      return {
        ...state,
        locale: action.payload,
      };
    }
    case ThemeSetting.CHANGE_NAV_STYLE: {
      return {
        ...state,
        navStyle: action.payload,
      };
    }
    case ThemeSetting.CHANGE_RT_ANIM: {
      return {
        ...state,
        rtAnim: action.payload,
      };
    }
    case ThemeSetting.UPDATE_PRIMARY_COLOR: {
      return {
        ...state,
        primary: action.payload,
      };
    }
    case ThemeSetting.UPDATE_SIDEBAR_COLOR: {
      return {
        ...state,
        sidebarColor: action.payload,
      };
    }
    case ThemeSetting.UPDATE_SECONDARY_COLOR: {
      return {
        ...state,
        secondary: action.payload,
      };
    }
    case HP_CustomActions.SET_LOGGED_USER: {
      console.log("payload", action.payload);
      if (
        action.payload?.user
        && action.payload.jwt
        && action.payload.rt
      ) {
        const p = action.payload.user as HPUser;
        localStorage.setItem("loggedUser", JSON.stringify(p));
        //localStorage.setItem(StorageKeyForJWT, action.payload.jwt);
        setJWT(action.payload.jwt);
        setRefreshToken(action.payload.rt);
        return {
          ...state,
          HPUser: {
            ...p,
            ruoli: (
              action.payload.user.ruolo?.includes(RoutePermittedRole.Admin) ?
              // RoutePermittedRole.Gestore
              (() => {
                if (p.ruoli.includes(RoutePermittedRole.Gestore)) {
                  return p.ruoli
                } else {
                  p.ruoli.push(RoutePermittedRole.Gestore)
                  return p.ruoli
                }
              })()
              :

              //condizione per ruolo freelancer
              (
                p.ruoli.length === 2
                &&
                p.ruoli.includes(RoutePermittedRole.Dipendente)
                &&
                p.ruoli.includes(RoutePermittedRole.Amministrativo)
                &&
                action.payload.user.idPartnerFreelance !== "00000000-0000-0000-0000-000000000000"
              )
              // &&
              // action.payload.user.ruolo?.includes(RoutePermittedRole.Dipendente)
              ?
              [RoutePermittedRole.Freelancer]
              :
              
              p.ruoli
            )
          },
          HP_JWT: action.payload.jwt,
          HP_RT: action.payload.rt,
          // user: {
          //   email: p.email,
          //   displayName: p.nome + " " + p.cognome,
          //   authType: defaultUser.authType,
          //   role: defaultUser.role,
          //   uid: defaultUser.uid
          // }
        }
      } else {
        localStorage.removeItem("loggedUser");
        // localStorage.removeItem(StorageKeyForJWT);
        removeJWT()
        localStorage.removeItem(StorageKeyForRefreshToken);
        return {
          ...state,
          HPUser: null,
          HP_JWT: null,
          HP_RT: null,
          user: null
        }
      }
    }
    case HP_CustomActions.SET_PENDING_PAYMENT: {
      console.warn("Pending payment found");
      return {
          ...state,
        pendingPayment: action.payload
      }
    }
    case HP_CustomActions.SET_IS_REFRESHING_TOKEN: {
      return {
          ...state,
          isRefreshingToken: action.payload
      }
    }
    default:
      return state;
  }
}
